import { render, staticRenderFns } from "./ReportNewBusinessLog.vue?vue&type=template&id=6c48ff36&"
import script from "./ReportNewBusinessLog.vue?vue&type=script&lang=js&"
export * from "./ReportNewBusinessLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports